import { Typography } from '~/UIKit';
import { TFunction } from 'i18next';
import React from 'react';
import { NewPasswordForm } from '../../Components/Forms';
import { makeStyles } from '~/UIKit/Style';

type RecoverPasswordNewPasswordComponentProps = {
  t: TFunction;
  onNewPasswordSubmit: (values: any) => void;
  passwordResetLoading: boolean;
};

const useStyles = makeStyles((theme) => ({
  container: {
    marginBottom: theme.spacing(4),
    textAlign: 'center',
    maxWidth: 360,
  },
  text: {
    marginBottom: theme.spacing(4),
  },
}));

const RecoverPasswordNewPassword = ({
  t,
  onNewPasswordSubmit,
  passwordResetLoading,
}: RecoverPasswordNewPasswordComponentProps) => {
  const { classes } = useStyles();

  return (
    <div className={classes.container}>
      <Typography data-testid="newPasswordTitle" variant="h5">
        {t('app.setNewPassword')}
      </Typography>
      <Typography className={classes.text} data-testid="resetEmailBody" variant="body2">
        {t('setNewPassword.text')}
      </Typography>
      <NewPasswordForm loading={passwordResetLoading} onSubmit={onNewPasswordSubmit} t={t} />
    </div>
  );
};

export default RecoverPasswordNewPassword;
